module.exports = __webpack_public_path__ + "img/MILLING_CUTTER.1542a862.jpg";